import type { JSX } from "solid-js";

import { i18n } from "@lingui/core";
import { I18nProvider as LinguiProvider } from "@lingui/solid";

import { type LocaleOptions, Language, Languages } from "./Languages";
import { messages as en } from "./catalogs/en/messages";
import { initTime, loadTimeLocale } from "./dayjs";
import { updateDurationLocale } from "./durations";

export function I18nProvider(props: { children: JSX.Element }) {
  i18n.load({
    en,
  });

  i18n.activate(Language.ENGLISH);

  initTime();

  updateDurationLocale(Language.ENGLISH);

  return <LinguiProvider i18n={i18n}>{props.children}</LinguiProvider>;
}

export { Language, Languages } from "./Languages";
export { timeLocale, useTime } from "./dayjs";
export { useError } from "./errors";

export async function loadAndSwitchLocale(
  key: Language,
  localeOptions: LocaleOptions,
) {
  if (key !== i18n.locale) {
    const data =
      Languages[key].i18n === "en"
        ? en
        : (await import(`./catalogs/${Languages[key].i18n}/messages.ts`))
            .messages;

    i18n.load({
      [key]: data,
    });

    i18n.activate(key);

    loadTimeLocale(Languages[key], localeOptions);

    updateDurationLocale(Language.ENGLISH);
  }
}

/**
 * Default language for new visitors.
 * Majalis is an English-language community, so we always start in English
 * and let people pick another language themselves in Settings.
 * @returns Preferred language
 */
export function browserPreferredLanguage() {
  return Language.ENGLISH;
}
